export const FeedbackConstant = {
    title: {en:"Was this answer helpful?", hi:"क्या यह जवाब उपयोगी था ?", or: "ଏହି ଉତ୍ତର କ’ଣ ସହାୟକ ଥିଲା?"},
    options: [
        {
            label: {en:"Yes", hi:"हाँ", or: "ହଁ"},
            value: "like",
            image: "likeIcon.svg"
        },
        {
            label: {en:"No", hi:"नहीं", or: "ନା"},
            value: "dislike",
            image: "dislikeIcon.svg"
        }
    ]
}

export const FeedbackValues = {
    "LIKE": "like",
    "DISLIKE": "dislike"
}